"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onFullScreen(event) {
  if (event.fullscreen) {
    this.props.onEnterFullScreen(event);
  } else {
    this.props.onExitFullScreen(event);
  }
}

exports.default = onFullScreen;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-full-screen.js
// module id = 1783
// module chunks = 1